import React, { useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar, Doughnut } from "react-chartjs-2";
import MainSidebar from "./Mainsidebar";
import UserNavbar from "./UserNavbar";
import UserFooter from "./UserFooter";
import AddStockModal from "./components/AddStockModal";
import AdjustInventoryModal from "./components/AdjustInventoryModal";
import "../Style/InventoryDashboard.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

export default function InventoryDashboard() {
  const [hamburger, sethamburger] = useState(true);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  // Filter States
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");

  // Modals state
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isAdjustModalOpen, setIsAdjustModalOpen] = useState(false);

  // Mock Inventory Items Data
  const [inventoryItems, setInventoryItems] = useState([
    {
      id: 1,
      sku: "SKU-9901",
      name: "Wireless Ergonomic Mouse",
      category: "Electronics",
      quantity: 145,
      reorderLevel: 30,
      warehouse: "Main Warehouse",
      binLocation: "Bin-A12",
      unitPrice: 49.99,
      status: "Optimal",
      supplier: "Global Tech Supplies",
      holdingCost: 2.5,
      profitMargin: "38%",
      turnover: "5.2x/yr",
    },
    {
      id: 2,
      sku: "SKU-8820",
      name: "Mechanical Gaming Keyboard",
      category: "Electronics",
      quantity: 12,
      reorderLevel: 25,
      warehouse: "East Coast Depot",
      binLocation: "Bin-B04",
      unitPrice: 89.99,
      status: "Low Stock",
      supplier: "Keytronics Inc.",
      holdingCost: 4.1,
      profitMargin: "42%",
      turnover: "8.1x/yr",
    },
    {
      id: 3,
      sku: "SKU-7731",
      name: "USB-C Fast Charging Hub",
      category: "Electronics",
      quantity: 0,
      reorderLevel: 40,
      warehouse: "Main Warehouse",
      binLocation: "Bin-A09",
      unitPrice: 29.99,
      status: "Out of Stock",
      supplier: "PowerLink Tech",
      holdingCost: 1.2,
      profitMargin: "45%",
      turnover: "9.4x/yr",
    },
    {
      id: 4,
      sku: "SKU-4412",
      name: "Stainless Steel Fastener Set",
      category: "Hardware",
      quantity: 520,
      reorderLevel: 100,
      warehouse: "West Coast Hub",
      binLocation: "Bin-C15",
      unitPrice: 15.5,
      status: "Optimal",
      supplier: "Apex Hardware Ltd.",
      holdingCost: 0.8,
      profitMargin: "30%",
      turnover: "3.5x/yr",
    },
    {
      id: 5,
      sku: "SKU-3329",
      name: "Heavy-Duty Packing Carton (L)",
      category: "Packaging",
      quantity: 850,
      reorderLevel: 200,
      warehouse: "Central Storage",
      binLocation: "Bin-D02",
      unitPrice: 3.2,
      status: "Overstocked",
      supplier: "PackCorp Solutions",
      holdingCost: 0.3,
      profitMargin: "25%",
      turnover: "1.8x/yr",
    },
    {
      id: 6,
      sku: "SKU-1105",
      name: "Legacy Serial Controller Module",
      category: "Electronics",
      quantity: 35,
      reorderLevel: 10,
      warehouse: "Central Storage",
      binLocation: "Bin-E99",
      unitPrice: 120.0,
      status: "Dead Stock",
      supplier: "OldTech Corp",
      holdingCost: 8.5,
      profitMargin: "15%",
      turnover: "0.0x/yr",
    },
  ]);

  const [fastMovers] = useState([
    { sku: "SKU-7731", name: "USB-C Fast Charging Hub", salesPerMonth: 420, velocity: "Very High" },
    { sku: "SKU-8820", name: "Mechanical Gaming Keyboard", salesPerMonth: 310, velocity: "High" },
    { sku: "SKU-9901", name: "Wireless Ergonomic Mouse", salesPerMonth: 280, velocity: "High" },
  ]);

  const [slowMovers] = useState([
    { sku: "SKU-1105", name: "Legacy Serial Controller Module", daysUnsold: 195, status: "Dead Stock" },
    { sku: "SKU-3329", name: "Heavy-Duty Packing Carton (L)", daysUnsold: 90, status: "Overstocked" },
  ]);

  const [supplierPerformances] = useState([
    { name: "Global Tech Supplies", onTimeRate: "98%", orderAccuracy: "99%", leadTime: "2 Days" },
    { name: "Keytronics Inc.", onTimeRate: "92%", orderAccuracy: "96%", leadTime: "4 Days" },
    { name: "Apex Hardware Ltd.", onTimeRate: "95%", orderAccuracy: "98%", leadTime: "3 Days" },
  ]);

  const [transferOrders] = useState([
    { id: "TO-1049", from: "Main Warehouse", to: "East Coast Depot", item: "Wireless Mouse", qty: 50, status: "In Transit" },
    { id: "TO-1050", from: "Central Storage", to: "West Coast Hub", item: "Packing Cartons", qty: 200, status: "Completed" },
  ]);

  // Screen Layout Handlers
  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  // Stock Handlers
  const handleAddStock = (newItem) => {
    setInventoryItems((prev) => [newItem, ...prev]);
  };

  const handleAdjustStock = (sku, newQty, reason) => {
    setInventoryItems((prev) =>
      prev.map((item) => {
        if (item.sku === sku) {
          let newStatus = "Optimal";
          if (newQty === 0) newStatus = "Out of Stock";
          else if (newQty <= item.reorderLevel) newStatus = "Low Stock";
          return { ...item, quantity: newQty, status: newStatus };
        }
        return item;
      })
    );
  };

  // Filter Computation
  const filteredItems = inventoryItems.filter((item) => {
    const matchesSearch =
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.sku.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.supplier.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesWarehouse =
      selectedWarehouse === "All" || item.warehouse === selectedWarehouse;
    const matchesCategory =
      selectedCategory === "All" || item.category === selectedCategory;
    return matchesSearch && matchesWarehouse && matchesCategory;
  });

  // Chart Data Configurations
  const warehouseChartData = {
    labels: ["Main Warehouse", "East Coast Depot", "West Coast Hub", "Central Storage"],
    datasets: [
      {
        label: "Current Stock Units",
        data: [665, 142, 520, 885],
        backgroundColor: "rgba(37, 99, 235, 0.85)",
        borderRadius: 6,
      },
      {
        label: "Reorder Threshold",
        data: [120, 80, 100, 210],
        backgroundColor: "rgba(245, 158, 11, 0.75)",
        borderRadius: 6,
      },
    ],
  };

  const warehouseChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: { font: { size: 11, family: "-apple-system, sans-serif" } },
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: { grid: { color: "#f1f5f9" }, beginAtZero: true },
    },
  };

  const categoryChartData = {
    labels: ["Electronics", "Hardware", "Packaging", "Office Supplies"],
    datasets: [
      {
        data: [192, 520, 850, 240],
        backgroundColor: ["#2563eb", "#10b981", "#f59e0b", "#64748b"],
        borderWidth: 2,
        borderColor: "#ffffff",
      },
    ],
  };

  const categoryChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right",
        labels: { font: { size: 11, family: "-apple-system, sans-serif" } },
      },
    },
    cutout: "68%",
  };

  // KPI Computations
  const totalStockValue = inventoryItems.reduce(
    (acc, curr) => acc + curr.quantity * curr.unitPrice,
    0
  );
  const outOfStockCount = inventoryItems.filter((i) => i.quantity === 0).length;
  const lowStockCount = inventoryItems.filter(
    (i) => i.quantity > 0 && i.quantity <= i.reorderLevel
  ).length;
  const deadStockCount = inventoryItems.filter(
    (i) => i.status === "Dead Stock"
  ).length;

  return (
    <div className="con1 d-flex">
      <div className="subcon1" style={handleclickonbutton1(hamburger)}>
        <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
      </div>
      <div className="subcon2" style={handleclickonbutton(hamburger)}>
        <UserNavbar
          hamburger={hamburger}
          sethamburger={sethamburger}
          handelRightMenuShow={handelRightMenuShow}
          handelShow={handelShow}
          isSearchShow={isSearchShow}
          handleScreenEnter={handleScreenEnter}
          handleScreenExit={handleScreenExit}
          fullScreen={fullScreen}
        />

        <div className="inventory-dashboard-wrapper">
          {/* Header & Quick Action Buttons */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
            <div>
              <h4 className="font-weight-bold mb-1 text-dark">
                <i className="fas fa-boxes text-primary mr-2"></i>Inventory Management
              </h4>
              <span className="text-muted small">
                Monitor real-time inventory levels, stock movement velocity, and operational alerts
              </span>
            </div>
            <div className="mt-3 mt-md-0 d-flex flex-wrap gap-2">
              <button
                className="btn btn-erp-primary mr-2 mb-2"
                onClick={() => setIsAddModalOpen(true)}
              >
                <i className="fas fa-plus mr-1.5"></i> Add Stock
              </button>
              <button
                className="btn btn-erp-outline mr-2 mb-2"
                onClick={() => setIsAdjustModalOpen(true)}
              >
                <i className="fas fa-sliders-h mr-1.5"></i> Adjust Count
              </button>
              <button
                className="btn btn-erp-outline mr-2 mb-2"
                onClick={() => alert("Purchase Order created successfully!")}
              >
                <i className="fas fa-file-invoice-dollar mr-1.5"></i> Place PO
              </button>
              <button
                className="btn btn-erp-outline mb-2"
                onClick={() => alert("Stock Valuation & Movement Report generated!")}
              >
                <i className="fas fa-download mr-1.5"></i> Export Report
              </button>
            </div>
          </div>

          {/* Section 1: Summary KPIs */}
          <div className="row mb-4">
            <div className="col-12 col-sm-6 col-lg-4 col-xl-2 mb-3">
              <div className="erp-card p-3 h-100">
                <div className="kpi-card-content">
                  <div>
                    <span className="kpi-label">Total Stock Value</span>
                    <div className="kpi-value">
                      ${totalStockValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </div>
                    <span className="kpi-trend text-success">
                      <i className="fas fa-arrow-up"></i> +4.5% vs last month
                    </span>
                  </div>
                  <div className="kpi-icon-badge kpi-icon-primary">
                    <i className="fas fa-dollar-sign"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4 col-xl-2 mb-3">
              <div className="erp-card p-3 h-100">
                <div className="kpi-card-content">
                  <div>
                    <span className="kpi-label">Turnover Rate</span>
                    <div className="kpi-value">4.8x</div>
                    <span className="kpi-trend text-muted">Annualized Velocity</span>
                  </div>
                  <div className="kpi-icon-badge kpi-icon-success">
                    <i className="fas fa-sync-alt"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4 col-xl-2 mb-3">
              <div className="erp-card p-3 h-100">
                <div className="kpi-card-content">
                  <div>
                    <span className="kpi-label">Stock Accuracy</span>
                    <div className="kpi-value">98.5%</div>
                    <span className="kpi-trend text-info">Physical Audit Score</span>
                  </div>
                  <div className="kpi-icon-badge kpi-icon-info">
                    <i className="fas fa-check-circle"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4 col-xl-2 mb-3">
              <div className="erp-card p-3 h-100">
                <div className="kpi-card-content">
                  <div>
                    <span className="kpi-label">Out of Stock</span>
                    <div className="kpi-value text-danger">{outOfStockCount}</div>
                    <span className="kpi-trend text-danger">Immediate Restock</span>
                  </div>
                  <div className="kpi-icon-badge kpi-icon-danger">
                    <i className="fas fa-exclamation-triangle"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4 col-xl-2 mb-3">
              <div className="erp-card p-3 h-100">
                <div className="kpi-card-content">
                  <div>
                    <span className="kpi-label">Low Stock</span>
                    <div className="kpi-value text-warning">{lowStockCount}</div>
                    <span className="kpi-trend text-warning">Below Threshold</span>
                  </div>
                  <div className="kpi-icon-badge kpi-icon-warning">
                    <i className="fas fa-exclamation-circle"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4 col-xl-2 mb-3">
              <div className="erp-card p-3 h-100">
                <div className="kpi-card-content">
                  <div>
                    <span className="kpi-label">Dead Stock</span>
                    <div className="kpi-value">{deadStockCount}</div>
                    <span className="kpi-trend text-muted">&gt; 90 Days Unsold</span>
                  </div>
                  <div className="kpi-icon-badge kpi-icon-secondary">
                    <i className="fas fa-archive"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Section 2: Compact Critical Alerts Bar */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="alerts-strip shadow-sm">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="font-weight-700 text-dark small text-uppercase letter-spacing-1">
                    <i className="fas fa-bell text-warning mr-1.5"></i> Operational Alerts &amp; Notifications
                  </span>
                  <span className="text-muted small">Updated Real-Time</span>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-6 col-lg-3 mb-2 mb-lg-0">
                    <div className="alert-pill-item alert-pill-danger">
                      <span><i className="fas fa-exclamation-triangle mr-1.5"></i> Stock Below Reorder</span>
                      <span className="badge badge-danger">{lowStockCount + outOfStockCount} SKUs</span>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3 mb-2 mb-lg-0">
                    <div className="alert-pill-item alert-pill-warning">
                      <span><i className="fas fa-boxes mr-1.5"></i> Overstocked Items</span>
                      <span className="badge badge-warning text-dark">1 SKU</span>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3 mb-2 mb-lg-0">
                    <div className="alert-pill-item alert-pill-info">
                      <span><i className="fas fa-truck-loading mr-1.5"></i> Pending Purchase Orders</span>
                      <span className="badge badge-info">3 POs</span>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="alert-pill-item alert-pill-slate">
                      <span><i className="fas fa-calendar-check mr-1.5"></i> Audit Schedule Due</span>
                      <span className="badge badge-secondary">2 Items</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Section 2.5: Visual Inventory Analytics (Charts) */}
          <div className="row mb-4">
            <div className="col-lg-7 mb-4 mb-lg-0">
              <div className="erp-card h-100">
                <div className="erp-card-header">
                  <h6><i className="fas fa-chart-bar text-primary mr-1.5"></i> Stock Levels by Warehouse</h6>
                  <span className="text-muted small">Live Quantity vs Reorder Point</span>
                </div>
                <div className="erp-card-body p-3" style={{ height: "240px" }}>
                  <Bar data={warehouseChartData} options={warehouseChartOptions} />
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="erp-card h-100">
                <div className="erp-card-header">
                  <h6><i className="fas fa-chart-pie text-info mr-1.5"></i> Stock Breakdown by Category</h6>
                  <span className="text-muted small">Category Share</span>
                </div>
                <div className="erp-card-body p-3" style={{ height: "240px" }}>
                  <Doughnut data={categoryChartData} options={categoryChartOptions} />
                </div>
              </div>
            </div>
          </div>

          {/* Section 3: Live Inventory Table */}
          <div className="erp-card mb-4">
            <div className="erp-card-header">
              <h6 className="mb-0"><i className="fas fa-layer-group text-primary mr-1.5"></i> Live Inventory Stock Levels</h6>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <div className="search-input-wrapper mr-2">
                  <i className="fas fa-search"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search SKU, Product, Supplier..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <select
                  className="form-control select-erp mr-2"
                  value={selectedWarehouse}
                  onChange={(e) => setSelectedWarehouse(e.target.value)}
                  style={{ width: "170px" }}
                >
                  <option value="All">All Warehouses</option>
                  <option value="Main Warehouse">Main Warehouse</option>
                  <option value="East Coast Depot">East Coast Depot</option>
                  <option value="West Coast Hub">West Coast Hub</option>
                  <option value="Central Storage">Central Storage</option>
                </select>
                <select
                  className="form-control select-erp"
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  style={{ width: "160px" }}
                >
                  <option value="All">All Categories</option>
                  <option value="Electronics">Electronics</option>
                  <option value="Hardware">Hardware</option>
                  <option value="Packaging">Packaging</option>
                </select>
              </div>
            </div>

            <div className="table-responsive">
              <table className="erp-table">
                <thead>
                  <tr>
                    <th>SKU Code</th>
                    <th>Product Name</th>
                    <th>Category</th>
                    <th>Stock Qty</th>
                    <th>Reorder Point</th>
                    <th>Warehouse</th>
                    <th>Bin Location</th>
                    <th>Unit Price</th>
                    <th>Status</th>
                    <th>Supplier</th>
                    <th className="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems.length > 0 ? (
                    filteredItems.map((item) => (
                      <tr key={item.sku}>
                        <td className="font-weight-600 text-primary">{item.sku}</td>
                        <td className="font-weight-600">{item.name}</td>
                        <td>
                          <span className="badge badge-light border">{item.category}</span>
                        </td>
                        <td>
                          <strong className="h6 mb-0">{item.quantity}</strong>
                        </td>
                        <td className="text-muted">{item.reorderLevel} units</td>
                        <td>{item.warehouse}</td>
                        <td>
                          <code className="text-dark bg-light px-2 py-0.5 rounded">{item.binLocation}</code>
                        </td>
                        <td>${item.unitPrice.toFixed(2)}</td>
                        <td>
                          {item.status === "Optimal" && (
                            <span className="badge-status badge-status-optimal">
                              <i className="fas fa-check-circle"></i> Optimal
                            </span>
                          )}
                          {item.status === "Low Stock" && (
                            <span className="badge-status badge-status-low">
                              <i className="fas fa-exclamation-circle"></i> Low Stock
                            </span>
                          )}
                          {item.status === "Out of Stock" && (
                            <span className="badge-status badge-status-out">
                              <i className="fas fa-times-circle"></i> Out of Stock
                            </span>
                          )}
                          {item.status === "Overstocked" && (
                            <span className="badge-status badge-status-over">
                              <i className="fas fa-boxes"></i> Overstocked
                            </span>
                          )}
                          {item.status === "Dead Stock" && (
                            <span className="badge-status badge-status-dead">
                              <i className="fas fa-archive"></i> Dead Stock
                            </span>
                          )}
                        </td>
                        <td className="text-muted small">{item.supplier}</td>
                        <td className="text-right">
                          <button
                            className="btn btn-sm btn-outline-secondary py-1 px-2"
                            onClick={() => setIsAdjustModalOpen(true)}
                            title="Adjust Count"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center py-4 text-muted">
                        No inventory records match the selected filters.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Section 4: Fast/Slow Movers, Supplier Performance & Demand AI Card */}
          <div className="row mb-4">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="erp-card h-100">
                <div className="erp-card-header">
                  <h6><i className="fas fa-tachometer-alt text-success mr-1.5"></i> Velocity Analytics (Fast vs Slow Movers)</h6>
                </div>
                <div className="erp-card-body p-0">
                  <div className="p-3 border-bottom">
                    <small className="font-weight-700 text-uppercase text-muted d-block mb-2">
                      <i className="fas fa-bolt text-warning mr-1"></i> Fast-Moving Inventory (Units / Month)
                    </small>
                    {fastMovers.map((fm) => (
                      <div key={fm.sku} className="d-flex justify-content-between align-items-center py-1.5 border-bottom border-light">
                        <div>
                          <strong className="d-block text-dark small">{fm.name}</strong>
                          <span className="text-muted text-xs">{fm.sku}</span>
                        </div>
                        <span className="badge badge-success px-2 py-1 font-weight-600">{fm.salesPerMonth} units/mo</span>
                      </div>
                    ))}
                  </div>

                  <div className="p-3">
                    <small className="font-weight-700 text-uppercase text-muted d-block mb-2">
                      <i className="fas fa-hourglass-half text-slate mr-1"></i> Stagnant / Slow-Moving Inventory
                    </small>
                    {slowMovers.map((sm) => (
                      <div key={sm.sku} className="d-flex justify-content-between align-items-center py-1.5">
                        <div>
                          <strong className="d-block text-dark small">{sm.name}</strong>
                          <span className="text-muted text-xs">{sm.sku}</span>
                        </div>
                        <span className="badge badge-secondary px-2 py-1">{sm.daysUnsold} Days Unsold</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="erp-card h-100 d-flex flex-column justify-content-between">
                <div>
                  <div className="erp-card-header">
                    <h6><i className="fas fa-handshake text-info mr-1.5"></i> Supplier Performance Matrix</h6>
                  </div>
                  <div className="table-responsive">
                    <table className="erp-table">
                      <thead>
                        <tr>
                          <th>Supplier Name</th>
                          <th>On-Time Rate</th>
                          <th>Accuracy</th>
                          <th>Lead Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {supplierPerformances.map((sp, idx) => (
                          <tr key={idx}>
                            <td className="font-weight-600">{sp.name}</td>
                            <td><span className="text-success font-weight-700">{sp.onTimeRate}</span></td>
                            <td>{sp.orderAccuracy}</td>
                            <td><span className="badge badge-light border">{sp.leadTime}</span></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Refined Executive AI Insight Card */}
                <div className="p-3">
                  <div className="ai-forecast-widget">
                    <div className="d-flex align-items-center mb-1">
                      <i className="fas fa-brain text-primary mr-2"></i>
                      <strong className="text-dark small text-uppercase letter-spacing-1">Demand Forecast Insight</strong>
                    </div>
                    <p className="text-muted small mb-0">
                      Based on 30-day velocity, <strong>USB-C Fast Charging Hubs</strong> will reach zero stock in 6 days. Recommended automated reorder quantity: <strong>250 units</strong>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Section 5: Warehouse Transfers & Financial Insights */}
          <div className="row mb-4">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="erp-card h-100">
                <div className="erp-card-header">
                  <h6><i className="fas fa-exchange-alt text-primary mr-1.5"></i> Inter-Warehouse Transfer Orders</h6>
                </div>
                <div className="table-responsive">
                  <table className="erp-table">
                    <thead>
                      <tr>
                        <th>Transfer ID</th>
                        <th>Origin</th>
                        <th>Destination</th>
                        <th>Product Item</th>
                        <th>Qty</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transferOrders.map((to) => (
                        <tr key={to.id}>
                          <td className="font-weight-700 text-primary">{to.id}</td>
                          <td>{to.from}</td>
                          <td>{to.to}</td>
                          <td>{to.item}</td>
                          <td>{to.qty}</td>
                          <td>
                            <span
                              className={`badge ${
                                to.status === "In Transit" ? "badge-warning" : "badge-success"
                              }`}
                            >
                              {to.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="erp-card h-100">
                <div className="erp-card-header">
                  <h6><i className="fas fa-coins text-warning mr-1.5"></i> Financial Metrics &amp; Holding Costs</h6>
                </div>
                <div className="erp-card-body">
                  <div className="row text-center">
                    <div className="col-4">
                      <div className="p-3 bg-light rounded border">
                        <small className="text-muted d-block text-uppercase font-weight-600">Holding Costs</small>
                        <h5 className="font-weight-bold text-dark mb-0 mt-1">$1,450/mo</h5>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="p-3 bg-light rounded border">
                        <small className="text-muted d-block text-uppercase font-weight-600">Stock Shrinkage</small>
                        <h5 className="font-weight-bold text-danger mb-0 mt-1">0.4%</h5>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="p-3 bg-light rounded border">
                        <small className="text-muted d-block text-uppercase font-weight-600">Avg Margin</small>
                        <h5 className="font-weight-bold text-success mb-0 mt-1">36.5%</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <UserFooter />
      </div>

      {/* Action Modals */}
      <AddStockModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onAddStock={handleAddStock}
      />
      <AdjustInventoryModal
        isOpen={isAdjustModalOpen}
        onClose={() => setIsAdjustModalOpen(false)}
        onAdjustStock={handleAdjustStock}
        items={inventoryItems}
      />
    </div>
  );
}
